import * as React from "react";
const SvgAccessDenied = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={80}
    height={80}
    fill="none"
    {...props}
  >
    <path
      fill="#082B60"
      d="M56.752 73.98H6.442c-4.36 0-7.464-4.248-6.129-8.399l5.293-16.539c1.706-5.31 7.514-8.06 12.694-6.05 3.443 1.336 7.867 2.382 13.29 2.382 5.421 0 9.845-1.046 13.289-2.381.193-.08.402-.145.61-.21v.403c0 9.508 7.064 17.392 16.218 18.679l1.19 3.716c1.32 4.151-1.769 8.398-6.145 8.398M31.605 39.196c9.161 0 16.588-7.427 16.588-16.588 0-9.16-7.427-16.587-16.588-16.587-9.16 0-16.587 7.426-16.587 16.587s7.426 16.588 16.587 16.588"
    />
    <path
      fill="#D23949"
      d="M64.346 27.532c-8.64 0-15.655 7.014-15.655 15.654S55.706 58.84 64.346 58.84 80 51.842 80 43.186 73 27.532 64.346 27.532m-.016 27.093a3.13 3.13 0 0 1-3.138-3.137c0-1.738 1.4-3.138 3.138-3.138s3.137 1.4 3.137 3.138-1.4 3.137-3.137 3.137m3.346-19.322-.644 8.816a2.67 2.67 0 0 1-2.67 2.478 2.67 2.67 0 0 1-2.671-2.478l-.644-8.816a3.323 3.323 0 0 1 3.315-3.572c1.914 0 3.443 1.64 3.314 3.572"
    />
  </svg>
);
export default SvgAccessDenied;
